// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Omni Environments API
 * API to manage Omni Development Environments
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const AuratypesSoftwareDependencyStage = {
  SoftwareDependencyStageBuild: 'build',
  SoftwareDependencyStageDeploy: 'deploy',
  SoftwareDependencyStageRuntime: 'runtime',
} as const;
export type AuratypesSoftwareDependencyStage =
  (typeof AuratypesSoftwareDependencyStage)[keyof typeof AuratypesSoftwareDependencyStage];

export function instanceOfAuratypesSoftwareDependencyStage(
  value: any,
): boolean {
  for (const key in AuratypesSoftwareDependencyStage) {
    if (
      Object.prototype.hasOwnProperty.call(
        AuratypesSoftwareDependencyStage,
        key,
      )
    ) {
      if (
        AuratypesSoftwareDependencyStage[
          key as keyof typeof AuratypesSoftwareDependencyStage
        ] === value
      ) {
        return true;
      }
    }
  }
  return false;
}

export function AuratypesSoftwareDependencyStageFromJSON(
  json: any,
): AuratypesSoftwareDependencyStage {
  return AuratypesSoftwareDependencyStageFromJSONTyped(json, false);
}

export function AuratypesSoftwareDependencyStageFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareDependencyStage {
  return json as AuratypesSoftwareDependencyStage;
}

export function AuratypesSoftwareDependencyStageToJSON(
  value?: AuratypesSoftwareDependencyStage | null,
): any {
  return value as any;
}

export function AuratypesSoftwareDependencyStageToJSONTyped(
  value: any,
  ignoreDiscriminator: boolean,
): AuratypesSoftwareDependencyStage {
  return value as AuratypesSoftwareDependencyStage;
}
